var zhCN = {
	"codeBlock.copied": "已复制",
	"codeBlock.copyLabel": "复制",
	"inlineCodeBlock.copied": "已复制",
	"inlineCodeBlock.copyLabel": "复制内联代码"
};

export { zhCN as default };
